module.exports = __webpack_public_path__ + "media/src/img/favicon-3e78b8b8e8112dcc84b97f43fd376b69.ico";